module.exports = __webpack_public_path__ + "img/ro.06bf7b18.svg";